import { EventEmitter, Injectable } from '@angular/core';
import { MessageHandlerService, MessageTypes } from './message-handler.service';

@Injectable()
export class ActivityTrackerService {
    onActivity = new EventEmitter();
    private _activityCount = 0;
    private _waitId: string | undefined;

    constructor(private _msgService: MessageHandlerService) {
    }

    activityStart() {
        //this._msgService.clearAll();
        if (!this._waitId) {
            this._waitId = this._msgService.setMessage(MessageTypes.Wait, 'Loading...');
        }
        this._activityCount++;
        this.onActivity.emit(this._activityCount);
    }

    activityStop() {
        this._activityCount--;
        if (this._activityCount < 0) {
            this._activityCount = 0;
        }
        if (this._activityCount === 0 && this._waitId) {
            this._msgService.clear(this._waitId);
            this._waitId = undefined;
        }
        this.onActivity.emit(this._activityCount);
    }
}
